export default ngModule => {

    ngModule.directive('zohoError', (AonConfig) => {
        return {
            restrict: 'E',
            template: require('../partials/zoho-api-error-modal.html'),
            scope: {
                error: '=',
            },
            link: (scope) => {
                const modal = $('.modal#zoho-api-error');
                // No idea why this is required, but multiple backdrop's are getting created.
                // This will remove all but one, so that the modal dismiss will return the
                // screen to normal state.
                modal.on('shown.bs.modal', function () {
                    $('.modal-backdrop').not(':first').remove();
                });
                scope.$watch('error', (error) => {
                    if (error) {
                        modal.modal('show');
                    }
                });
            },
        };
    });
}


// WEBPACK FOOTER //
// ./src/directives/zoho-error.js